export class KnowledgeItemsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getKnowledgeItems({ skipForbiddenError = false } = {}) {
    return this.#http.get('/knowledge-items', {
      ...(skipForbiddenError && { skipResponseInterceptor: { forbiddenError: true } }),
    });
  }

  async getKnowledgeItem(id) {
    return this.#http.get(`/knowledge-items/${id}`);
  }

  async getKnowledgeItemContent(id) {
    return this.#http.get(`/knowledge-items/${id}/content`);
  }

  async createKnowledgeItem(body, { isGlobal = false } = {}) {
    return this.#http.post('/knowledge-items', body, { params: { isGlobal } });
  }

  async updateKnowledgeItem({ id, ...body }) {
    return this.#http.put(`/knowledge-items/${id}`, body);
  }

  async deleteKnowledgeItem(id) {
    return this.#http.delete(`/knowledge-items/${id}`);
  }

  async getStepKnowledgeItems(aiProcessId, stepId, { skipForbiddenError = false } = {}) {
    return this.#http.get(`/api/ai-processes/${aiProcessId}/steps/${stepId}/knowledge-items`, {
      ...(skipForbiddenError && { skipResponseInterceptor: { forbiddenError: true } }),
    });
  }

  async setStepKnowledgeItems(aiProcessId, stepId, knowledgeItemIds) {
    return this.#http.put(
      `/api/ai-processes/${aiProcessId}/steps/${stepId}/knowledge-items`,
      knowledgeItemIds,
    );
  }

  async getChatConfigurationKnowledgeItems(chatConfigurationId) {
    return this.#http.get(`/chat-configurations/${chatConfigurationId}/knowledge-items`);
  }

  async setChatConfigurationKnowledgeItems(chatConfigurationId, knowledgeItemIds) {
    return this.#http.put(
      `/chat-configurations/${chatConfigurationId}/knowledge-items`,
      knowledgeItemIds,
    );
  }
}
